// ============================================================================
// RESIZE HANDLE COMPONENT
// ============================================================================

export default function ResizeHandle({ columnKey, onResizeStart }) {
  return (
    <div
      onMouseDown={(e) => {
        e.stopPropagation();
        onResizeStart(columnKey, e);
      }}
      onDragStart={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      draggable={false}
      style={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: 8,
        cursor: 'col-resize',
        userSelect: 'none',
        zIndex: 100,
        backgroundColor: 'transparent',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'rgba(0, 115, 234, 0.3)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
    />
  );
}
